import React, { Component } from "react"
import styled from "@emotion/styled"

const GWrapper = styled.div`
    position: relative;
    & table {
        margin: unset;
        border-collapse: unset;
        table-layout: unset;
    }

    & .gsc-control-cse {
        border: 0 !important;
        padding: 0;
    }
    & form.gsc-search-box,
    table.gsc-search-box {
        margin-bottom: 0;
    }
    & input.gsc-input {
        color: ${(props) => props.theme.colors.text1};
    }
    & .gsc-search-box table {
        border: 0 !important;
        background: #e4befb;
        & .gsib_a {
            background: ${(props) => props.theme.colors.background};
        }
        & .gsib_b {
            background: ${(props) => props.theme.colors.background};
            padding: 0;
        }
        & td {
            border: 0 !important;
        }
    }
    & .gsc-search-button {
        color: ${(props) => props.theme.colors.primary};
        background: #e4befb;
        cursor: pointer;
        border: 0;
        & :hover {
            background: ${(props) => props.theme.colors.secondary};
        }
        & svg {
            fill: ${(props) => props.theme.colors.primary};
        }
    }
`

class GoogleSearch extends Component {
    componentDidMount() {
        ;(function () {
            var cx = "188fb137f5ce9451e"
            var gcse = document.createElement("script")
            gcse.type = "text/javascript"
            gcse.async = true
            gcse.src = "https://cse.google.com/cse.js?cx=" + cx
            var s = document.getElementsByTagName("script")[0]
            s.parentNode.insertBefore(gcse, s)
        })()
    }

    render() {
        return (
            <GWrapper>
                <div className="gcse-search" />
            </GWrapper>
        )
    }
}

export default GoogleSearch
